import React from "react";
import { Box, Button } from "@mui/material";
import AxionControls from "../../../components/controls/AxionControls";
import { FormattedMessage } from "react-intl";
import messages from "./messages";

export default function MachineSectionAddEditDialog(props) {
    return (
        <Box sx={{ p: 1, m: 1 }}>
            <Box sx={{ width: 400 }}>
                <AxionControls.AxionTextBox
                    name="name"
                    label={<FormattedMessage {...messages.nameColumn} />}
                    value={props.machineSection.name}
                    onChange={props.onChange}
                />
            </Box>
            <Box sx={{ width: 400 }}>
                <AxionControls.AxionTextBox
                    name="code"
                    label={<FormattedMessage {...messages.codeColumn} />}
                    value={props.machineSection.code ?? ""}
                    onChange={props.onChange}
                />
            </Box>
            <Box sx={{ width: 400 }}>
                <AxionControls.AxionTextBox
                    name="sortOrder"
                    label={<FormattedMessage {...messages.sortOrderColumn} />}
                    value={props.machineSection.sortOrder ?? 0}
                    onChange={props.onChange}
                />
            </Box>
            <Box>
                <Button
                    variant="contained"
                    sx={{ marginTop: 2 }}
                    onClick={props.handleSave}
                >
                    <FormattedMessage {...messages.saveButton} />
                </Button>
            </Box>
        </Box>
    );
}
